import Cookies from 'js-cookie';
import scrollSmooth from 'scroll-smooth';
import Swiper from 'swiper/bundle'; 

class BtnTop{
	constructor(){
		this.btn = document.querySelector('.j-btn-top');
		this.btnMain = document.querySelector('.j-btn-top-main');
		window.addEventListener('scroll', () => {
			this.scroll();
		});
		this.scroll();
	}

	scroll(){
		if(window.pageYOffset > 200){
			this.btn.style.opacity = 1;
			this.btnMain.style.pointerEvents = 'auto';
		}else{
			this.btn.style.opacity = 0;
			this.btnMain.style.pointerEvents = 'none';
		}
	}
}

class StructureSlider{
	constructor(){
		this.slider = document.querySelector('.j-structure-slider');
		if(!this.slider) return;
		this.swiperElm = this.slider.querySelector('.swiper');
		this.paginationElm = this.slider.querySelector('.swiper-pagination');
		this.btnNext = this.slider.querySelector('.j-structure-slider-next');
		this.btnPrev = this.slider.querySelector('.j-structure-slider-prev');
		
		this.init();
	}

	init(){
		this.swiper = new Swiper(this.swiperElm, {
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			speed: 400,
			// autoplay: {
			// 	delay: 5000,
			// },
			navigation: {
				nextEl: this.btnNext,
				prevEl: this.btnPrev,
			},
			pagination: {
				el: this.paginationElm,
				clickable: true,
			}
		});
	}
}

(() => {
	
	const setSmoothScroll = () => {
		const anchors = Array.from(document.querySelectorAll('.j-anchor-link'));
		console.log(anchors);

		anchors.map((anchor) => {
			anchor.addEventListener('click', (e) => {
				e.preventDefault();
				let href = anchor.getAttribute('href');
				href = href.replace('#', '');
				let target = document.getElementById(href);
				if(!target) target = document.getElementsByTagName('body')[0];
				scrollSmooth.to(target);
				return false;
			}, false);
		});
	}

	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.footer-btn a').forEach(el => {
			const img = el.querySelector('img');
			const src = img.getAttribute('src');
			let srcs = src.split('off.');
			let onSrc = srcs[0] + 'on.' + srcs[1];
			let preloadImg = document.createElement('img');
			preloadImg.src = onSrc;

			el.addEventListener('mouseenter', e => {
				img.setAttribute('src', onSrc);
			});
			el.addEventListener('mouseleave', e => {
				img.setAttribute('src', src);
			});
		});

		setSmoothScroll();
		new BtnTop();
		new StructureSlider();
	});
})();

